import React, { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  en: {
    "app.name": "WORKAHOLIC HR Solution",
    "nav.dashboard": "Dashboard",
    "nav.myportal": "My Portal",
    "nav.employees": "Employees",
    "nav.leave": "Leave",
    "nav.attendance": "Attendance",
    "nav.claims": "Claims",
    "nav.payroll": "Payroll",
    "nav.approvals": "Approvals",
    "nav.settings": "Settings",
    "nav.admin": "Platform Admin",
    "common.logout": "Log out",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.submit": "Submit",
    "common.search": "Search",
    "common.loading": "Loading...",
    "common.status": "Status",
    "common.actions": "Actions",
    "common.approve": "Approve",
    "common.reject": "Reject",
    "common.view": "View",
    "common.period": "Period",
    "dash.title": "HR Overview",
    "dash.headcount": "Headcount",
    "dash.joiners": "Joiners (This Month)",
    "dash.leavers": "Leavers",
    "dash.turnover": "Turnover Rate",
    "dash.payrollcost": "Employer Cost (Latest)",
    "dash.pending": "Pending Approvals",
    "dash.late": "Late This Month",
    "dash.leaveutil": "Leave Utilisation",
    "dash.costchart": "Payroll Cost Trend",
    "dash.deptchart": "Headcount by Department",
    "dash.contracts": "Contracts Expiring (60 days)",
    "landing.login": "Sign in with Google",
    "admin.viewas": "Viewing customer dashboard",
    "admin.exitview": "Exit View",
    "admin.view": "View",
  },
  bm: {
    "app.name": "WORKAHOLIC HR Solution",
    "nav.dashboard": "Papan Pemuka",
    "nav.myportal": "Portal Saya",
    "nav.employees": "Pekerja",
    "nav.leave": "Cuti",
    "nav.attendance": "Kehadiran",
    "nav.claims": "Tuntutan",
    "nav.payroll": "Gaji",
    "nav.approvals": "Kelulusan",
    "nav.settings": "Tetapan",
    "nav.admin": "Admin Platform",
    "common.logout": "Log keluar",
    "common.save": "Simpan",
    "common.cancel": "Batal",
    "common.submit": "Hantar",
    "common.search": "Cari",
    "common.loading": "Memuatkan...",
    "common.status": "Status",
    "common.actions": "Tindakan",
    "common.approve": "Lulus",
    "common.reject": "Tolak",
    "common.view": "Lihat",
    "common.period": "Tempoh",
    "dash.title": "Gambaran HR",
    "dash.headcount": "Bilangan Pekerja",
    "dash.joiners": "Pekerja Baharu (Bulan Ini)",
    "dash.leavers": "Berhenti",
    "dash.turnover": "Kadar Pusing Ganti",
    "dash.payrollcost": "Kos Majikan (Terkini)",
    "dash.pending": "Kelulusan Tertangguh",
    "dash.late": "Lewat Bulan Ini",
    "dash.leaveutil": "Penggunaan Cuti",
    "dash.costchart": "Trend Kos Gaji",
    "dash.deptchart": "Pekerja Mengikut Jabatan",
    "dash.contracts": "Kontrak Tamat (60 hari)",
    "landing.login": "Log masuk dengan Google",
    "admin.viewas": "Memapar dashboard pelanggan",
    "admin.exitview": "Keluar Paparan",
    "admin.view": "Lihat",
  },
};

const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("nexahr_lang") || "en");
  useEffect(() => {
    localStorage.setItem("nexahr_lang", lang);
  }, [lang]);
  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);

export const fmtRM = (n) =>
  "RM " + Number(n || 0).toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-MY", { day: "numeric", month: "short", year: "numeric" }) : "-");
